import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message, Empty } from 'antd'

import { searchRedimableRewards } from '../../Rewards/services'

import { storeEmployeeReward } from '../services'
import { handleError } from '../../../helpers'

export default function NewEmployeeRewardModal({ visible, onClose, reload }) {
    const { user, token } = useSelector(state => state.auth)
    const { register, handleSubmit, formState: { errors } } = useForm()
    const [redimableRewards, setRedimableRewards] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        !redimableRewards && searchRedimableRewards(user.id, token)
            .then(res => setRedimableRewards(res.data.data))
            .catch(error => handleError(error))
    }, [redimableRewards, user.id, token])

    const onSubmit = values => {
        setLoading(true)
        values.employee_id = user.id
        storeEmployeeReward(values)
            .then(res => {
                message.success("Tu solicitud fue registrada exitosamente, pronto recibirás un correo con los detalles para usar tu bono.", 10)
                reload()
                onClose()
            })
            .catch(error => handleError(error, setLoading))
    }

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Nueva solicitud de redención de puntos</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group>
                            <Form.Label>Premio a redimir <span className='text-primary'>*</span></Form.Label>
                            { redimableRewards?.length > 0 ? (
                                <Form.Control
                                    as="select"
                                    {...register('reward_id', { required: true })}
                                >
                                    <option value="">:: Seleccione un premio ::</option>
                                    { redimableRewards.map(reward => (
                                        <option key={reward.id} value={reward.id}>
                                            {reward.name} ({reward.points_required} puntos requeridos)
                                        </option>
                                    )) }
                                </Form.Control>
                            ) : (
                                <Empty description="No tiene premios redimibles" />
                            )}
                            { errors.reward_id && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
                        </Form.Group>
                        <Button color="primary" type="submit" disabled={loading}>
                            Solicitar redención de puntos
                        </Button>
                    </Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}